import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

body, html {
  height: 100%;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  //MATERIAL UI PARTICULARIDADES
  .MuiStepIcon-root.MuiStepIcon-active {
    color:${(props) => props.theme.primary.light};
  }

  .MuiInput-underline:before {
    border-bottom: 1.5px solid rgba(211, 169, 113, 0.55) !important;
  }

  .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom-color: #d3a971 !important;
  }

  .MuiInput-underline:after {
    border-bottom-color: #e7a73f !important;
  }

  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{
    :hover{
      background-color: transparent !important;
      border:0 !important;
    }
  }


  .MuiInputBase-root.MuiInput-root{
    color:#3c4d62;
    padding-left:15px;
    
  }

  .MuiAvatar-root{
     background-color:${(props) => props.theme.primary.original} !important;
  }

  .MuiButtonBase-root.MuiIconButton-root{
    :hover{
 border-color:${(props) => props.theme.primary.light};
    color:${(props) => props.theme.primary.light};
    }
  }


  .MuiFormControl-root .MuiTextField-root{
   :hover{
        color:${(props) => props.theme.primary.light};
    }

  }  
  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: rgba(211, 169, 113, 0.55) !important;
    border-radius: 8px;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #d3a971 !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #e7a73f !important;
    border-width: 1px !important;
  }

  .MuiOutlinedInput-root.Mui-focused {
    box-shadow: 0 0 0 2px rgba(231, 167, 63, 0.2);
  }

  .MuiAutocomplete-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #d3a971 !important;
  }


   input{
    &::placeholder {
      color: #a3a3a3 !important;
    }
  }

  textarea, input { outline: none; }

  a:link {text-decoration: none}
    a:visited {text-decoration: none }
    a:active {text-decoration: none }

    ::-webkit-scrollbar {
      height: 7px;
      width: 7px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }
    
    ::-webkit-scrollbar-thumb {
       background: #989898; 
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background:  #E0E0E0; 
    }

  @media (max-width: 1080px) {
    html {
      font-size: 93.75%;
      
    }
  }

  @media (max-width: 720px) {
    html {
      font-size: 87.5%;
    }
  }

  body{
    background: #FFF;
    overflow-x: hidden;
  }

  input[type="date"]{
    cursor: pointer;
  }

  input[type='date']::-webkit-calendar-picker-indicator {
    filter: none;
    font-weight: bolder;
    font-size: 18px;

    :hover {
     font-size:20px;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      filter: invert(0.5) sepia(0.5) saturate(10) hue-rotate(152deg);

    }
  }

@media (max-width: 720px) {
  html {
    font-size: 87.5%!important;
  }

  button:not(.btn-primary):not(.btn-outline):not(.btn-secondary),
  .MuiButton-root,
  .MuiButtonBase-root {
    font-size: 0.9em !important;
    padding: 0.45em 0.9em !important;
  }
}

//FONTS COLOR
h2, h1, h3, h4 {
  color: ${(props) => props.theme.fonts.title};
}

h5 , h6{
    color: ${(props) => props.theme.fonts.subtitle};
}

  input, button, textarea, select{
    :disabled{
      color:    ${(props) => props.theme.fonts.disable_text};
    }
  }


  body,
  input,
  textarea,
  select,
  button {
    font: 400 1rem "Instrument Sans", sans-serif;
  }

  button, a {
    cursor: pointer;
  }
  a {
    color: inherit;
    text-decoration: none;
      :hover {
        transform: scale(1.1);
        backface-visibility: hidden;
        -webkit-font-smoothing: subpixel-antialiased;
        transition: all 0.2s ease-in-out;
      }
  }
}`;
